import React, { useState } from 'react';
import styled from 'styled-components';
import { Row, Col, Card } from 'antd';
import { ResponseHomeFont } from 'modules/font';
import FontCardPage from 'pages/font-page/FontCardPage';
import { ROUTE_FONT_CARD_PAGE, ROUTE_ROOT } from 'routes/const';
import { history } from 'modules/store';
import { useHistory } from 'react-router';
import { fontData } from '../../../lib/fontData';
import { Link } from 'react-router-dom';

interface MainCardProps {
  data: ResponseHomeFont[];
}

const StyledMainCard = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  padding-bottom: 100px;
`;

export const MainCard = (props: MainCardProps) => {
  const { data } = props;
  const [fontData, setFontData] = useState<ResponseHomeFont[]>([]);
  const history = useHistory();

  const handleFontData = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const num = Number(e.currentTarget.id);

    if (data) {
      data.map(arr => {
        if (arr.id === num) {
          setFontData([arr]);
        }
        history.push(ROUTE_FONT_CARD_PAGE, fontData);
      });
    }
  };

  return (
    <StyledMainCard>
      <Row gutter={[16, 24]}>
        {data.map((arr, idx) => {
          return (
            <Col className='gutter-row' span={6} key={idx}>
              <Link
                to={{
                  pathname: ROUTE_FONT_CARD_PAGE,
                  state: arr
                }}
              >
                <Card
                  onClick={e => handleFontData(e)}
                  hoverable
                  key={idx}
                  id={`${arr.id}`}
                  cover={<img alt={arr.title} src={arr.thumbnails} />}
                >
                  <Card.Meta title={arr.title} description={arr.enUS} />
                </Card>
              </Link>
            </Col>
          );
        })}
      </Row>
    </StyledMainCard>
  );
};
